interface ValidationResult {
    isValid: boolean;
    message: string;
    safeFileName: string;
    extension: string;
  }
  
  const validateFileName = (file: File, allowedExtensions: string[]): ValidationResult => {
    const parts = file.name.split('.');
    
    if (parts.length <= 1) {
      return { isValid: false, message: "File must have a valid extension", safeFileName: file.name, extension: "" };
    }
    
    const extension = parts[parts.length - 1].toLowerCase();
    const safeFileName = parts.slice(0, -1).join('.');
    const hasDoubleExtension = parts.length > 2;
    
    if (!allowedExtensions.includes(extension)) {
      return {
        isValid: false,
        message: `File type .${extension} is not allowed. Allowed types: ${allowedExtensions.join(', ')}`,
        safeFileName,
        extension
      };
    }
    
    if (hasDoubleExtension) {
      return {
        isValid: false,
        message: "Files with multiple extensions are not allowed",
        safeFileName,
        extension
      };
    }
    
    // Allow spaces in file names for Excel and CSV files
    const isExcelOrCsv = ['xls', 'xlsx', 'csv'].includes(extension);
    
    // For Excel/CSV files, allow spaces and more characters
    if (isExcelOrCsv) {
      // Only disallow problematic characters that could cause issues with file systems
      // eslint-disable-next-line no-control-regex
      const invalidChars = /[<>:"/\\|?*\x00-\x1f]/;
      if (invalidChars.test(safeFileName)) {
        return {
          isValid: false,
          message: "File name contains invalid characters. Please avoid: < > : \" / \\ | ? * and control characters",
          safeFileName,
          extension
        };
      }
    }
    
    return { isValid: true, message: "File is valid", safeFileName, extension };
  };
  
  export default validateFileName;
  
  
  